import styled, { css } from 'styled-components';
import { TableContainer } from '@material-ui/core';

export const Wrapper = styled(TableContainer)`
  ${({ maxHeight }) => css`
    max-height: calc(100vh - ${maxHeight}rem);
  `}
`;
